import { useState, useCallback } from "react";

interface ConfirmState {
  visible: boolean;
  title: string;
  message?: string;
  confirmLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
}

export function useConfirm() {
  const [state, setState] = useState<ConfirmState>({
    visible: false,
    title: "",
    onConfirm: () => {},
  });

  const confirm = useCallback(
    (opts: {
      title: string;
      message?: string;
      confirmLabel?: string;
      destructive?: boolean;
    }): Promise<boolean> => {
      return new Promise((resolve) => {
        setState({
          visible: true,
          title: opts.title,
          message: opts.message,
          confirmLabel: opts.confirmLabel,
          destructive: opts.destructive,
          onConfirm: () => {
            setState((s) => ({ ...s, visible: false }));
            resolve(true);
          },
        });
      });
    },
    []
  );

  const cancel = useCallback(() => {
    setState((s) => ({ ...s, visible: false }));
  }, []);

  return {
    confirmProps: {
      visible: state.visible,
      title: state.title,
      message: state.message,
      confirmLabel: state.confirmLabel,
      destructive: state.destructive,
      onConfirm: state.onConfirm,
      onCancel: cancel,
    },
    confirm,
  };
}
